module.exports = __webpack_public_path__ + "static/suburban_350-a3b1235a1eb168536b46c35f8982257f.jpg";